import { formatDuration, formatSince, parseTime } from '@/lib/conversationFormat';
import { useServerNow } from './useServerNow';

/**
 * Small self-ticking time texts. Each owns its interval, so a ticking waiting
 * time re-renders one <span>, not the whole list or chat around it.
 */

/** "1:42" since `since`, ticking every second. */
export function ElapsedClock({ since, until }: { since: string | null | undefined; until?: string | null }) {
  const ended = parseTime(until);
  const now = useServerNow(1000, ended === null);
  const start = parseTime(since);
  if (start === null) return null;
  return <span className="tabular-nums">{formatDuration((ended ?? now) - start)}</span>;
}

/** "seit 2 h", refreshed every 30 s. */
export function SinceText({ since }: { since: string | null | undefined }) {
  const now = useServerNow(30_000);
  const start = parseTime(since);
  if (start === null) return null;
  return <span>{formatSince(Math.max(0, now - start))}</span>;
}
